import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import {
  Button,
  Input,
  InputIcon,
  Modal
} from '@salesforce/design-system-react';

import './ImageURLModal.scss';

class ImageURLModal extends Component {
  constructor(props) {
    super(props);
    this.modalName = 'imageURL';
  }

  handleSubmit() {
    const imageUrl = this.props.modals?.assetWizard?.data?.asset?.image_url;
    if (imageUrl) {
      this.props.onSubmit(imageUrl);
    }
  }

  renderModal() {
    const { formatMessage } = this.props.intl;
    const data = this.props.data;
    const asset = this.props.modals.assetWizard?.data?.asset || {};
    const label = formatMessage({ id: 'components.ecs.imageURLModal.info' });
    const imagePlaceholder = formatMessage({
      id: 'components.ecs.imageURLModal.placeholder'
    });
    const onBlur = () => {
      if (this.props.onFieldBlur) {
        this.props.onFieldBlur(data, this.fields);
      }
    };
    const clearButton = (
      <InputIcon
        assistiveText={{
          icon: 'Clear'
        }}
        name="clear"
        category="utility"
        onClick={event => {
          let existing_asset = this.props.modals.assetWizard?.data?.asset || {};
          delete existing_asset.image_url;
          if (!!existing_asset.original_image_url) {
            this.props.actions.updateModal('assetWizard', {
              errors: { image_url: '' },
              existing_asset
            });
          } else {
            this.props.actions.updateModal('assetWizard', {
              step0: { completed: false },
              errors: { image_url: '' },
              existing_asset
            });
          }
        }}
      />
    );

    let imageUrlInput = data.value || '';
    if (data.value && data.value.startsWith('data:image')) {
      imageUrlInput = '';
    } else if (!!asset?.contentBuilderAsset && !asset?.image_url) {
      imageUrlInput = '';
    }
    return (
      <Input
        key={`${data.field}-field`}
        className="field-input"
        value={imageUrlInput}
        label={label}
        errorText={data.errorText}
        onBlur={onBlur}
        onChange={this.props.onChange.bind(this)}
        placeholder={imagePlaceholder}
        iconRight={imageUrlInput ? clearButton : null}
      />
    );
  }

  renderFooter() {
    const { formatMessage } = this.props.intl;
    const hasUrl = this.props.data?.value?.length > 1 || false;
    const hasError = this.props.data?.errorText?.length > 0 || false;
    /**
     * Cancel
     */
    const cancelLabel = formatMessage({
      id: this.getI18nID('actionButtons.cancel')
    });
    const cancelButton = (
      <Button
        label={cancelLabel}
        variant="neutral"
        onClick={this.closeModal.bind(this)}
      />
    );

    /**
     * Add
     */
    const addLabel = formatMessage({
      id: this.getI18nID(`actionButtons.add`)
    });

    const addButton = (
      <Button
        label={addLabel}
        disabled={hasError || !hasUrl}
        variant="brand"
        onClick={this.handleSubmit.bind(this)}
      />
    );

    return (
      <div className="footer-button-actions">
        {cancelButton}
        {addButton}
      </div>
    );
  }

  getI18nID(suffix) {
    return `components.ecs.imageURLModal.${suffix}`;
  }

  closeModal() {
    let existing_asset = this.props.modals.assetWizard?.data?.asset || {};
    delete existing_asset.image_url;
    this.props.actions.updateModal('assetWizard', {
      errors: { image_url: '' },
      existing_asset
    });
    this.props.actions.closeModal(this.modalName);
  }

  render() {
    const { formatMessage } = this.props.intl;
    const isOpen = this.props.modals[this.modalName]?.isOpen;
    const modalTitle = formatMessage({
      id: this.getI18nID('title')
    });

    if (!isOpen) {
      return null;
    }

    return (
      <Modal
        className={this.modalName}
        heading={modalTitle}
        footer={this.renderFooter()}
        onRequestClose={this.closeModal.bind(this)}
        dismissOnClickOutside={false}
        disableClose={true}
        isOpen={isOpen || false}
      >
        {this.renderModal()}
      </Modal>
    );
  }
}

ImageURLModal.propTypes = {
  actions: PropTypes.object.isRequired,
  modals: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(ImageURLModal);
